import { Translate } from '@hydra/common/components';
import React, { useState } from 'react';
import { SWRConfig } from 'swr';

interface ErrorDisplayContextValue {
  error?: Error | null;
  setError: (err: Error) => void,
  clearError: () => void;
}
const ErrorDisplayContext = React.createContext<ErrorDisplayContextValue>({
  error: null,
  setError: async () => {},
  clearError: () => {}
});

export default function ErrorDisplay ({ children }: React.PropsWithChildren<{}>) {
  const [error, setError] = useState<Error|null>(null);
  const clearError = () => setError(null);
  const displayChildren = true;
  const errorDisplayComponent = null;

  const defaultErrorDisplayComponent = <Translate content='shopify_default_error_message' />;
  const contextValue = { setError, clearError, error };
  return (
    <SWRConfig value={{
      onError: (error, key) => {
      // automatically have this display handle all errors generated by swr
        setError(error);
      }
    }}
    >
      <ErrorDisplayContext.Provider value={contextValue}>
        {error ? (errorDisplayComponent || defaultErrorDisplayComponent) : null}
        {displayChildren ? children : null}
      </ErrorDisplayContext.Provider>
    </SWRConfig>
  );
}

export function useErrorDisplay (): ErrorDisplayContextValue {
  return React.useContext(ErrorDisplayContext);
}
